module.exports = __webpack_public_path__ + "img/backstage.670fcd46.png";